<template>
  <div>
    <div class="sayfahead m-0">
      <h1><small>Dönem İşlemleri</small></h1>

      <el-button v-if="BinaBilgi.Duzenle" type="success" size="small" class="YeniBtn"
                 @click="YeniBtn">
        Dönem Ekle
      </el-button>
    </div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      :title="DonemTitle"
      type="error"
      :closable="false"
      v-if="!BinaBilgi.Duzenle">
    </el-alert>
    <el-table
      v-if="Liste"
      :data="Liste"
      class="golgetable yazdirma">
      <el-table-column
        label="Dönem Başlangıç Tarihi"
        prop="basTarihiText"
      >
      </el-table-column>
      <el-table-column
        label="Aidat Bedeli"
        prop="Borclandirma"
      >
      </el-table-column>

      <el-table-column
        align="right">

        <template slot-scope="scope">


          <el-button-group>
            <el-tooltip v-if="Yetki" class="item" effect="dark" content="Düzenle"
                        placement="top-start">
              <i
                class="feather-edit-2  tableibtn text-primary"
                @click="DuzenleBtn(scope.row)"></i>

            </el-tooltip>
            <el-tooltip v-if="Yetki" class="item" effect="dark" content="İşletme Projesi Yazdır"
                        placement="top-start">
              <i
                class="feather-printer tableibtn text-success"
                @click="Yazdir(scope.row.Yazdir)">
              </i>

            </el-tooltip>

            <el-tooltip v-if="Yetki" class="item" effect="dark"
                        content="Sil"
                        placement="top-start">
              <i
                class="feather-trash tableibtn text-danger"
                @click="SilOnay(scope.row.id)">
              </i>
            </el-tooltip>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <IsletmeProjesiYazdir v-if="Yazici" :Veri="Veri" @Yazdirildi="Yazici=false"></IsletmeProjesiYazdir>
    <BinaDonemDetay :BinaBilgi="BinaBilgi" :Donem="Donem" :Modal="BinaDonemDetayModal"
                    @BinaDonemDetayModal="SayfaYukle"></BinaDonemDetay>
  </div>
</template>

<script>
import IsletmeProjesiYazdir from "../../../Genel/IsletmeProjesiYazdir";
import BinaDonemDetay from "./BinaDonemDetay";
import Yukleniyor from "../../../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor, BinaDonemDetay, IsletmeProjesiYazdir},
  props: ["BinaBilgi", "DonemTitle"],
  data() {
    return {
      BinaDonemDetayModal: false,
      lo: true,
      Donem: null,
      Liste: null,
      Yetki: false,
      Veri: null,
      Yazici: false
    }
  },
  methods: {
    Yazdir(veri) {
      this.Veri = veri
      this.Yazici = true
    },
    SilOnay(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Sil(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil(id) {
      this.$store.dispatch("Delete", {...this.Form, path: 'yonetim/bina/donem/' + id})
        .then(response => {
          if (response.Durum == "OK") {
            this.ModalOlayi = false;
            this.$message.success(response.Mesaj);
            this.SayfaYukle();
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },
    DuzenleBtn(veri) {
      this.BinaDonemDetayModal = true;
      this.Donem = veri;
    },
    YeniBtn() {
      this.Donem = null;
      this.BinaDonemDetayModal = true;
    },
    SayfaYukle() {
      this.BinaDonemDetayModal = false;
      this.lo = true;
      this.$store.dispatch("Get", {path: 'yonetim/bina/donem/' + this.BinaBilgi.id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Liste = response.Liste;
            this.lo = false;

          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    }
  },
  created() {
    this.SayfaYukle();
    this.Yetki = this.$store.getters.Yetki.yonetim == '2' ? true : false;
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Tab/BinaDonem.vue